<template>
  <div class="preview-item" @click="previewFullscreen">
    <div class="headline">
      <p class="d-flex">
        <span class="name">{{ data.name }}</span>
      </p>

      <span class="size">
        {{ $utils.matchTagSize(data.size) }} mm
      </span>
    </div>
    
    <div class="thumbail-wrapper">
      <div
        class="tag-thumbnail"
        :style="{backgroundImage: `url(${previewImage})`}"
      ></div>
    </div>
  </div>
</template>

<script>
import KeysMixin from '@/mixins/keys';
export default {
  name: 'DetailPreview',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mixins:[
    KeysMixin
  ],
  created() {
    this.renderImage()
  },
  methods: {
    async renderImage() {
      let {
        keys,
        size,
        tenant_id
      } = this.data
      if (!size || !keys) return
      keys = await this._setLogoByData(keys, tenant_id)

      this.$utils.renderTagImage(keys, size)
      .then(res => {
        if (res) {
          this.previewImage = res
        }
      })
    },
    previewFullscreen() {
      this.$utils.fullScreenTemplatePreview(this.previewImage)
    }
  },
  data() {
    return {
      previewImage: undefined
    }
  }
}
</script>

<style lang="less" scoped>
  .preview-item {
    padding: 74px 56px 80px;
    background-image: url('~@/assets/image/template-bg-end.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .headline, .footline {
      display: flex;
      justify-content: space-between;
    }
    .headline {
      font-size: 40px;
      .name {
        color: @primary-color;
        margin: 0 22px 0 0;
      }
      .size {
        color: @primary-color;
      }
    }
    .thumbail-wrapper {
      padding: 14px;
      background-color: #eee;
      width: 100%;
      height: 370px;
      margin: 30px 0;
    }
    .tag-thumbnail {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
</style>